import React from 'react'

const AppToaster = (props) => {
    const {showToaster,setShowToaster,toaster} = props;
  return (
    <>
      <div className="position-fixed bottom-4 end-0 p-3" style={{ zIndex: 10 }}>
          <div className={`toast ${showToaster ? 'show' : 'hide'}`} role="alert" aria-live="assertive" aria-atomic="true">
            <div className={`toast-header ${toaster.type == 'success' ? 'bg-primary text-white' : 'bg-danger text-white'}`}>

              <strong className="me-auto">{toaster.heading}</strong>
              <small>few seconds ago</small>
              <button type="button" className="btn-close" onClick={()=>setShowToaster(false)} data-bs-dismiss="toast" aria-label="Close" />
            </div>
            <div style={{zIndex:1000}} className="toast-body">
              {Array.isArray(toaster.message)?(
                    toaster.message.map((eachmessage)=>(
                      <p>{eachmessage}</p>
                    ))
              ):(toaster.message)}
            </div>
          </div>
        </div>
    </>
  )
}

export default AppToaster
